import {useLoadOnce} from '@common'
import {NavigationPathKey, TranslationKey} from '@enums'
import {Box, Typography} from '@mui/material'

import logo from '@images/amplio-logo.png'

import {useCallbackModel} from './callback-model'
import {ContentContainer, imageStyle} from './style'

/**
 * Callback page
 */
export function CallbackPage() {
  const {onCallback, t, navigate} = useCallbackModel()

  useLoadOnce(() => {
    onCallback()
  })

  return (
    <ContentContainer>
      <Box component="img" src={logo} style={imageStyle} onClick={() => navigate(NavigationPathKey.DASHBOARD)} />
      <Typography variant="h2">{`${t(TranslationKey['Redirecting. Please wait.'])}..`}</Typography>
    </ContentContainer>
  )
}
